<template>
  <div class="homePage">
    <div class="mainLeft">
      <div class="homeBanner"
           :style="{height: carouselHeight + 'px'}"
           ref="banner">
        <Carousel :height="carouselHeight"
                  loop
                  autoplay
                  :autoplay-speed="5000"
                  :width="carouselWidth + 'px'">
          <Carousel-item v-for="(item) in carouselList"
                         :key="item.table_id">
            <div><img class="carouselImg"
                   :style="{height: carouselHeight + 'px'}"
                   :src="item.img_url ? baseUrl2 + item.img_url : '' " /></div>
          </Carousel-item>
        </Carousel>
      </div>
      <div class="homeMenu">
        <Card :bordered="true">
          <p slot="title">{{lang=='zh' ? chName.quickentrance : enName.quickentrance}}</p>
          <div class="homeMenuList">
            <div class="homtMemuItem"
                 v-for="(item,index) in contextMenuList"
                 :key="index">
              <img  @click="contextMenuTo(item)" :src="require('../../assets/'+item.icon)" />
              <span @click="contextMenuTo(item)" style="margin-top:5px">{{lang=='zh' ? item.chName : item.enName}}</span>
            </div>
          </div>
          <Divider dashed />
          <div class="homeMenuDeteil">
            <Icon type="md-create"
                  size="16" />
            <span @click="jumpMenuSetting">{{lang=='zh' ? chName.editshortcut : enName.editshortcut}}</span>
          </div>
        </Card>
      </div>
      <div class="homeUserinfo">
        <Card :bordered="true">
          <p slot="title">{{lang=='zh' ? chName.personalinformation : enName.personalinformation}}</p>
          <div class="userinfoHeader">
            <div class="userinfoLeft">
              <!-- <img src="../../assets/icon0010.png" /> -->
              <img :src="require('../../assets/indexImg0.jpg')" />
              <div style="margin-left:10px">
                <p style="font-size:16px;color:#000000;line-height:32px;font-weight: bold;">{{userinfoItem.userName}}</p>
                <p>{{userinfoItem.empCode}}</p>
                <p>出生日期:1986-06-02</p>
              </div>
            </div>
            <div class="userinfoDetail"
                 @click="userinfoDetailClick"><img src="../../assets/icon00055.png" /></div>
          </div>
          <Divider />
          <Card class="userinfoList">
                <p slot="title"><Icon type="md-people" size="22" style="margin-right:10px;"/>团队信息</p>
                <div class="team">
                    <div class="teamBox">
                        <Avatar :src="require('../../assets/indexImg1.jpg')"  size="large"/>
                        <div class="teamContent">
                            <span>孙明</span>
                            <p>销售经理 西南区</p>
                        </div>
                    </div>
                    <div class="teamBox">
                        <Avatar :src="require('../../assets/indexImg2.jpg')"  size="large"/>
                        <div class="teamContent">
                            <span>汪峰</span>
                            <p>销售总监 东南区</p>
                        </div>
                    </div>
                    <div class="teamBox">
                        <Avatar :src="require('../../assets/indexImg3.jpg')"  size="large"/>
                        <div class="teamContent">
                            <span>张全</span>
                            <p>销售顾问 西南区</p>
                        </div>
                    </div>
                    <div class="teamBox">
                        <Avatar :src="require('../../assets/indexImg0.jpg')"  size="large"/>
                        <div class="teamContent">
                            <span>刘洋</span>
                            <p>销售总监 东北区</p>
                        </div>
                    </div>
                    <div class="teamBox">
                        <Avatar icon="ios-person" size="large"/>
                        <div class="teamContent">
                            <span>李言</span>
                            <p>销售顾问 华南区</p>
                        </div>
                    </div>
                </div>
            </Card>
          <!-- <div class="userinfoList">
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0012.png" />
                <span>{{lang=='zh' ? conChName.orgsname2 : conEnName.orgsname2}}</span>
              </div>
              <span>{{userinfoItem.orgcode1}}</span>
            </div>
            <Divider dashed />
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0013.png" />
                <span>{{lang=='zh' ? conChName.orgsname4 : conEnName.orgsname4}}</span>
              </div>
              <span>{{userinfoItem.orgcode2}}</span>
            </div>
            <Divider dashed />
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0014.png" />
                <span>{{lang=='zh' ? chName.post : enName.post}}</span>
              </div>
              <span>{{userinfoItem.positionName}}</span>
            </div>
            <Divider dashed />
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0015.png" />
                <span>{{lang=='zh' ? chName.directleader : enName.directleader}}</span>
              </div>
              <span>{{userinfoItem.managerName}}</span>
            </div>
            <Divider dashed />
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0016.png" />
                <span>{{lang=='zh' ? chName.hiredate : enName.hiredate}}</span>
              </div>
              <span>{{date.dateVal(userinfoItem.hiredate, "YYYY/MM/DD")}}</span>
            </div>
            <Divider dashed />
            <div class="userinfoItem">
              <div>
                <img src="../../assets/icon0017.png" />
                <span>Email</span>
              </div>
              <span>{{userinfoItem.email}}</span>
            </div>
          </div> -->
        </Card>
      </div>
    </div>

    <div class="mainRight">
      <div class="homeMessage">
        <Card :bordered="false">
          <p slot="title">{{lang=='zh' ? chName.notice : enName.notice}}</p>
          <a href="#"
             slot="extra"
             @click.prevent="goNoticeDetail">
            <Icon type="ios-more"
                  style="color:#515a6e"
                  size="24" />
          </a>
          <div @click="noticeToDetail($event)">
            <vue-seamless-scroll :data="noticeList"
                                 :class-option="classOption"
                                 class="seamless-warp">
              <ul class="item">
                <li v-for="(item, index) in noticeList"
                    :key="index"
                    :data-id="item.id">
                  <div class="download_outer">
                    <div class="download_left">
                      <img v-if="(index&1) === 0"
                           src="../../assets/icon0018.png" />
                      <img v-else
                           src="../../assets/icon0018.png" />
                      <div>
                        <div class="title"
                             v-html="item.subject"></div>
                        <div><span style="margin-right:10px">{{ item.editor }}</span>{{ date.dateVal(item.updated_date, "YYYY/MM/DD") }}</div>
                      </div>
                    </div>
                    <div>
                      <Icon type="ios-arrow-forward"
                            size="18" />
                    </div>
                  </div>
                  <Divider dashed />
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div class="slotTit"
               @click="goDetail">
            <span>Q&A</span>
            <!-- <Icon type="ios-more"
                  size="24"
                  style="cursor: pointer;" /> -->
              <Badge :count="countData">
                    <Icon type="ios-more"
                      size="24"
                      style="cursor: pointer;" />
              </Badge>
          </div>
          <div class="homeQA">
            <Carousel loop
                      arrow="always"
                      :autoplay="false"
                      dots="none"
                      :autoplay-speed="5000"
                      style="height:220px"
                      @on-change="qaChange">
              <Carousel-item v-for="(item,index) in qaList"
                             :key="index">
                <div class="QABox">
                  <div class="QAleft">
                    <img class="dot"
                         src="../../assets/home/homeQ.png" />
                    <div class="QAline"></div>
                    <img class="dot"
                         src="../../assets/home/homeA.png" />
                  </div>
                  <div class="QAright">
                    <span>{{item.qaTitle}}</span>
                    <div>{{item.replyWord}}</div>
                  </div>
                </div>
              </Carousel-item>
            </Carousel>
            <div class="carPageNum">{{qaChangeNum}}/{{qaList.length}}</div>
          </div>
        </Card>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
  data () {
    return {
      spinShow:false,
      date: new DateUtil(),
      carouselHeight: 300,
      carouselWidth: '',
      userId: '',
      baseUrl1: '/api/staticSiteIcon/',
      baseUrl2: '/api/staticSiteImg/',
      carouselList: [],
      contextMenuList: [],
      noticeList: [],
      empData: {},
      userinfoItem: {},
      qaList: [],
      qaChangeNum: 1,
      chName:{},
      enName:{},
      conChName:{},
      conEnName:{},
      menuSerialnumber : "",
      countData:null
    }
  },
  computed: {
     //国际化监听
     lang(){
        return this.$store.getters.selectLangeData
      },
    classOption () {
      return {
        step: 0.3,
        limitMoveNum: this.noticeList.length,
        openWatch: true,
      }
    },
  },
  created () {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = userInfo.userId
    this.menuSerialnumber = userInfo.serialnumber
    this.getCarouselList()
    this.getContextMenu()
    this.getNoticeList()
    this.getEmpInformation()
    this.getQAInformation()
    // 查询国际化字段
    this.getViewSet()
    // 获取共同的国际化配置
    this.getContractViewSet()
  },
  methods: {
    contextMenuTo(item){
      item.be_external_links == '0' ? this.$router.push({ path: item.skip_URL }) : window.open(item.skip_URL);
    },
    getContractViewSet(){
      let Obj = {
          viewType:"Contract_Renew",
          beUsed : "1"
       } 
       this.spinShow=true
       axios.post('/International/applySelectViewSet',Obj).then((res) => {
          this.conChName= res.data[0]
          this.conEnName= res.data[1]
          // console.log(this.chName)
          this.spinShow=false
        })
    },
    getViewSet(){
       let Obj = {
          viewType:"Home_Page",
          beUsed : "1"
       } 
       this.spinShow=true
       axios.post('/International/applySelectViewSet',Obj).then((res) => {
          this.chName= res.data[0]
          this.enName= res.data[1]
          this.spinShow=false
        })
    },
    // 获取轮播列表
    getCarouselList () {
      axios.post('/homepage/get', {}).then(res => {
        if (res != null && res.length > 0) {
          this.carouselList = JSON.parse(JSON.stringify(res))
        }
      })
    },
    // 获取快捷菜单列表
    getContextMenu () {
      // 根据权限查询快捷菜单
      axios.post('/context/powerHomePage', { show_flag: true, user_id: this.menuSerialnumber }).then(res => {
        if (res != null && res.length > 0) {
          this.contextMenuList = JSON.parse(JSON.stringify(res))
        }
      })
      // 原查询快捷菜单
      // axios.post('/context/homepage', { show_flag: true, user_id: this.menuSerialnumber }).then(res => {
      //   if (res != null && res.length > 0) {
      //     this.contextMenuList = JSON.parse(JSON.stringify(res))
      //   }
      // })
    },
    // 获取公告信息列表
    getNoticeList () {
      axios.post('/announcement/selAnnouncementInfo', {}).then(res => {
        if (res != null && res.length > 0) {
          var noticeListOrg = JSON.parse(JSON.stringify(res))
          var date = new Date();
          this.noticeList = noticeListOrg.filter((item, index) => {
            let d = new Date(item.end_time)
            if (date < d) {
              return item
            }
          })
        }
      })
    },
    // 点击公告，跳转到公告详情
    noticeToDetail (e) {
      var nodeLi = e.path.filter((item) => item.nodeName == 'LI');
      this.$router.push({
        path: '/96D9F7FFBA3ECC423C7C703D2880C8FE723C91EC71D46066/A3FFBEBFDB713E27',
        query: { id: nodeLi[0].dataset.id }
      })
    },
    goNoticeDetail () {
      this.$router.push('/93BA2C413FC5E5888161B696F446D778753763A96EE59159/A3FFBEBFDB713E27')
    },
    // 获取员工信息
    getEmpInformation () {
      axios.post('/EmployeeInfor/getHomepageEmployeeInfo', { userId: this.serialnumber }).then((res) => {
        if (res && res != null) {
          this.userinfoItem = res
        }
      })
    },
    // 获取QA信息
    getQAInformation () {
      // axios.post('/qaListSet/selectQaListSet', { beReply: '1' }).then(res => {
      //   if (res) {
      //     this.qaList = res.data
      //   }
      axios.post('/qaListSet/selectHomePageQaList', { questionerId: this.menuSerialnumber }).then(res => {
        if (res) {
          this.qaList = res.ObjectData.data
          this.countData=Number(res.countData)
        }
      })
    },
    qaChange (oldval, val) {
      this.qaChangeNum = val + 1
    },
    userinfoDetailClick () {
      this.$router.push({
        path: '/95CAAAF222E7A036748785D9561E7187/A3FFBEBFDB713E27',
        query: {}
      })
    },
    jumpMenuSetting () {
      this.$router.push("/3020982F88DAB96B847B6D994B7209CF/A3FFBEBFDB713E27")
    },
    goDetail () {
      // this.$router.push("/C0F994D621530A70/A3FFBEBFDB713E27") 
      this.$router.push("/61AB63E6DE1EF633AB0757BB3048AF07B7578999FE53335EBA610C6A6F738319/A3FFBEBFDB713E27")
    }
  },
  mounted () {
    window.onresize = () => {
      this.carouselHeight = document.documentElement.clientHeight / 3.123
      this.carouselWidth = this.$refs.banner.carouselWidth;
    }
    this.$nextTick(() => {
      this.carouselHeight = document.documentElement.clientHeight / 3.123
    })
  },

  beforeDestroy () {
    window.onresize = null
  },
}
</script>

<style lang="scss" scoped>
.carouselImg {
  width: 100%;
  margin: 0 auto;
}
.homePage {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  .mainLeft {
    width: 66%;
    margin-right: 20px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    .homeBanner {
      width: 100%;
      margin-bottom: 20px;
    }
    .homeMenu {
      width: 48%;
      .homeMenuList {
        display: flex;
        flex-wrap: wrap;
        .homtMemuItem {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 30%;
          align-items: center;
          margin: 6px 2% 16px 1%;
          img {
            width: 70px;
            height: 70px;
            margin-bottom: 10px;
          }
        }
      }
      .homeMenuDeteil {
        text-align: center;
      }
    }
    .homeUserinfo {
      width: 48%;
      margin-left: 4%;
      .userinfoHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .userinfoLeft {
          display: flex;
          align-items: center;
          img {
            width: 70px;
            height: 70px;
          }
        }
        .userinfoDetail {
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
      .userinfoList {
        .userinfoItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          div {
            display: flex;
            align-items: center;
            span {
              color: #6f7c91;
            }
          }
          img {
            width: 22px;
            height: 22px;
            margin-right: 5px;
          }
          span {
            color: #000000;
          }
        }
        .team{
            height: 210px;
            overflow-y: auto;
             display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            box-sizing: border-box;
            align-items: flex-start;
            align-content: flex-start;
        }
        .teamBox {
            display: flex;
            align-items: center;
            box-sizing: border-box;
            width: 100%;
            margin: 5px 0;
            .teamContent {
                width: calc(100% - 40px - 20px);
                height: 60px;
                border: 1px solid #eeeeee;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                padding: 10px;
                box-sizing: border-box;
                margin:0 10px
            }
        }
      }
    }
  }

  .mainRight {
    width: 30%;
  }
}

.homeMessage {
  .slotTit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      font-size: 16px;
      color: #17233d;
      font-weight: bold;
    }
  }
  .QABox {
    background: #f7f7fe;
    height: 180px;
    width: 100%;
    padding: 20px;
    margin-top: 15px;
    border-radius: 10px;
    display: flex;
    align-items: flex-start;
    .QAleft {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .QAline {
        width: 0px;
        height: 40px;
        border-left: 1px dashed #6f7c91;
      }
    }
    .QAright {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      span {
        line-height: 30px;
        font-size: 14px;
        color: #000000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      div {
        margin-top: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
    }
  }
  .dot {
    width: 30px;
    height: 30px;
  }
  .carPageNum {
    text-align: center;
  }
}
.homeMessage /deep/.ivu-carousel {
  .ivu-carousel-arrow.right {
    margin-top: 120px !important;
    background-color: #f7f7fe;
    color: #8CD29B;
    right: 20% !important;
  }
  .ivu-carousel-arrow.left {
    margin-top: 120px !important;
    background-color: #f7f7fe;
    color: #8CD29B;
    left: 20% !important;
  }
}
/deep/.ivu-timeline {
  .ivu-timeline-item-head {
    background: transparent;
  }
}

.seamless-warp {
  // height: calc(100vh - 360px - 51px - 64px);
  height: 460px;
  overflow: hidden;
  .item {
    .download_outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .download_left {
        display: flex;
        align-items: center;
        .title {
          font-size: 12px;
          color: #000000;
          margin-bottom: 10px;
          font-weight: normal;
        }
        h2 {
          font-size: 12px;
          color: #000000;
        }
        img {
          width: 80px;
          height: 80px;
          margin-right: 15px;
          
        }
      }
      img {
        width: 40px;
        height: 40px;
       
      }
    }
  }
}

/deep/.ivu-card {
  .ivu-card-head {
    border-bottom-width: 0px;
    p {
      font-weight: bold;
    }
  }
}
/deep/.ivu-card-body {
  padding: 20px;
}
/deep/.ivu-divider-horizontal {
  margin: 18px 0;
}
@media screen and (max-width: 1210px) {
  .homePage {
    .mainLeft {
      width: 50%;
      .homeMenu {
        width: 100%;
      }
      .homeUserinfo {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
      }
    }

    .mainRight {
      width: 46%;
    }
  }
}
@media screen and (max-width: 900px) {
  .homePage {
    .mainLeft {
      width: 100%;
      .homeMenu {
        width: 100%;
      }
      .homeUserinfo {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
      }
    }

    .mainRight {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/HomePage.vue